import { Action, Dispatch } from 'redux'
import { initCouponsAction } from 'reducks/coupon/actions'

const initCoupons = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initCouponsAction())
  }
}

export default initCoupons
